import React, { useState, useEffect } from 'react';
import { Form, Select, Input } from 'antd';
import { useRefCode } from 'hooks';
import type { SelectProps } from 'antd';
import { selectBoxFilterOption } from 'utils/form-utils';

interface FormItemProps {
  form: any
}

const BusinessPartFormItem = ({form}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [codeList, setCodeList] = useState<SelectProps['options']>([]);

  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList: businessPartList } = useRefCode({field:'business_part', status_type: 'AV'});  

  /* ======================================================
  * events
  * ====================================================== */  

  /* ======================================================
  * effects
  * ====================================================== */  
  useEffect(() => {
    const options = businessPartList?.map((item) => {return {value: item.name, label: item.value}}) || [];
    setCodeList(options);
  }, [businessPartList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
      <Form.Item name="business_part">
        <Select 
          placeholder="사업부서 선택" 
          options={codeList} style={{width:"180px"}}/>                
      </Form.Item> 
  );
};

export default BusinessPartFormItem;
